import { usePointInTime } from './universe/usePointInTime';
import { useEligibilityRules } from './eligibility/useEligibilityRules';
import { useBenchmarkSelection } from './benchmark/useBenchmarkSelection';

/**
 * Orchestrator hook for the StartingUniverse step.
 * Composes section-level hooks and bridges to the Zustand store.
 */
export function useStartingUniverse() {
  const pointInTime = usePointInTime();
  const eligibility = useEligibilityRules(
    pointInTime.geographicScope,
    pointInTime.cyclicality,
    pointInTime.selectedUniverse?.coverageLabel,
  );
  const benchmark = useBenchmarkSelection(pointInTime.universeId);

  return { pointInTime, eligibility, benchmark };
}
